module.exports = __webpack_public_path__ + "img/warn_03.f4a4c3fd.png";